

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"width":"28","height":"29","viewBox":"0 0 28 29","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, rest), ["\n", h('g', {"clip-path":"url(#svg-success-sign-15wfA1U)"}, ["\n", h('path', {"d":"M11.0499 24.4238C10.7826 24.6927 10.4179 24.8427 10.0391 24.8427C9.66032 24.8427 9.29566 24.6927 9.02839 24.4238L0.956397 16.3506C0.118701 15.5129 0.118701 14.1545 0.956397 13.3184L1.96713 12.3074C2.80509 11.4697 4.16189 11.4697 4.99959 12.3074L10.0391 17.3471L23.6567 3.72935C24.4946 2.89165 25.8527 2.89165 26.6891 3.72935L27.6999 4.74034C28.5375 5.57804 28.5375 6.93615 27.6999 7.77254L11.0499 24.4238Z","fill":"#528B18"}, []), "\n"]), "\n", h('defs', {}, ["\n", h('clipPath', {"id":"svg-success-sign-15wfA1U"}, ["\n", h('rect', {"width":"28","height":"28","fill":"white","transform":"translate(0 0.30127)"}, []), "\n"]), "\n"]), "\n"]);
};

        